import { disclaimerText, LLM_MODEL } from '../lib/languages.js';
import { useModalBehaviour } from '../hooks/useModalBehaviour.js';

// Shown on demand, and automatically the first time a non-English language is
// picked — the point is that the reader knows the text they are about to read
// was machine-translated before they act on it.
export function DisclaimerModal({ open, lang, mode, onClose }) {
  useModalBehaviour(open, onClose, { lockScroll: true });

  return (
    <div
      className={`i18n-disclaimer-overlay${open ? ' active' : ''}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="i18n-disclaimer-modal">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h3>Translation Notice</h3>
        <p>{disclaimerText(lang, mode)}</p>
        <span className="llm-badge">Powered by {LLM_MODEL}</span>
      </div>
    </div>
  );
}
